import React from 'react';
import { find } from 'lodash';
import { useParams } from 'react-router-dom';
import { Translate } from 'core/translate';
import Modal, {
  ModalBody,
  ModalButtonPair,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton,
  ModalHeader,
} from '../../components/modal/Modal';
import ModalImage from '../../components/modal/ModalImage';
import { SimpleOptionPrice } from '../options/SimpleOptionCard';
import PackagePricing from '../../components/packages/PackagePricing';
import LegalDisclosure from '../../components/legalDisclosure/LegalDisclosure';

const getDescription = (option) => {
  const { longCfd, extendedCfd } = option;

  return longCfd || extendedCfd;
};

const OptionDetailsInner = ({ option, showImageDisclosure }) => {
  const { largeImageUrl, shortCfd, disclaimer } = option;
  const description = getDescription(option);

  return (
    <>
      <LegalDisclosure
        className="legal-disclosure--option-details"
        showAsStatic
      />
      <div className="option-details__container">
        <div className="option-details">
          <div
            dangerouslySetInnerHTML={{ __html: description }}
            className="option-details__description"
          />
          <div
            dangerouslySetInnerHTML={{ __html: disclaimer }}
            className="option-details__disclaimer"
          />
        </div>
        <ModalImage
          url={largeImageUrl ? largeImageUrl : null}
          alt={shortCfd}
          showImageDisclosure={showImageDisclosure}
        />
      </div>
    </>
  );
};

const OptionDetails = ({
  options,
  onSelect,
  onClose,
  children,
  type,
  showImageDisclosure,
  moreOptions,
  option,
}) => {
  const { id } = useParams();
  const displayOption =
    option || (options && options[id]) || find(moreOptions, { code: id });
  const {
    shortCfd: header,
    primaryName: headerFallback,
    selected,
  } = displayOption;

  return (
    <Modal
      isOpen={true}
      contentLabel={displayOption.code}
      onRequestClose={onClose}>
      <ModalHeader
        text={header || headerFallback}
        msrp={
          type === 'package' ? (
            <PackagePricing
              className="modal-header__msrp__package-pricing"
              option={displayOption}
            />
          ) : (
            <SimpleOptionPrice option={displayOption} />
          )
        }
        onClose={onClose}
        analyticsKey={header || headerFallback}
      />
      <ModalBody>
        {children ? (
          children
        ) : (
          <OptionDetailsInner
            option={displayOption}
            showImageDisclosure={showImageDisclosure}
          />
        )}
      </ModalBody>
      <ModalFooter className="modal-footer--option-details">
        <ModalFooterButtons classModifier="option-details">
          {selected ? (
            <ModalFooterPrimaryButton
              className="option-details__footer-button stat-button-link"
              onSelect={onClose}
              data-dtm={header || headerFallback}>
              <Translate value={'byo.page.general.ok'} />
            </ModalFooterPrimaryButton>
          ) : (
            <ModalButtonPair>
              <ModalFooterCancelButton
                className="option-details__footer-button stat-button-link"
                onClose={onClose}
                data-dtm={header}
              />
              <ModalFooterPrimaryButton
                className="option-details__footer-button stat-button-link"
                onSelect={() => onSelect(displayOption)}
                data-dtm={header}>
                <Translate value={'byo.page.general.select'} />
              </ModalFooterPrimaryButton>
            </ModalButtonPair>
          )}
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

OptionDetails.defaultProps = {
  type: '',
};

export { getDescription, OptionDetailsInner };

export default OptionDetails;
